import type { BillingSettings } from '@/core'
import type { CoreState } from '@/core/store/types'

export const getActiveBillingSettings = (
  state: CoreState
): BillingSettings[] => {
  return state.billingSettings.filter(
    (settings) => settings.brandId === state.activeBrand
  )
}
